import "./ArticleEmpty.css";

export default function ArticleEmpty() {
    return (
        <div className="article-empty">

            <div className="article-empty__icon">
                📚
            </div>

            <h3>
                مقاله‌ای پیدا نشد
            </h3>

            <p>
                در این دسته‌بندی مقاله‌ای برای نمایش وجود ندارد.
            </p>

        </div>
    );
}